export enum QrPackageTypeEnum {
  OBJECTS = 'OBJECTS',
  SERVICES = 'SERVICES',
  USERS = 'USERS',
  USER_DEVICES = 'USER_DEVICES',
  USER_OBJECTS = 'USER_OBJECTS',
  USER_SERVICES = 'USER_SERVICES',
  ORGANIZATIONS = 'ORGANIZATIONS',
  DEVICES = 'DEVICES',
  ORG_USERS = 'ORG_USERS',
  ORG_DEVICES = 'ORG_DEVICES',
  ORG_OBJECTS = 'ORG_OBJECTS',
  ORG_SERVICES = 'ORG_SERVICES',
  WITNESS = 'WITNESS',
  OBJECT_WITNESSES = 'OBJECT_WITNESSES',
  SERVICE_WITNESSES = 'SERVICE_WITNESSES',
}
